import React from "react";
import DocList from "../../_components/Sales/SalesDocList";
import { FiFileText, FiClock, FiCheckCircle, FiXCircle, FiUser, FiDollarSign, FiCreditCard, FiHome, FiHash, FiCalendar } from "react-icons/fi";
import { T, fmtMYR } from "../../_components/Sales/SalesShared";
import { getSalesOrders, getSalesOrderKpis, deleteSalesOrder } from "../../_services/sales.service";

export default function SalesOrders() {
    return (
        <DocList
            docType="Sales Order"
            basePath="/sales/sales-orders"
            fetchList={getSalesOrders}
            fetchKpis={getSalesOrderKpis}
            deleteItem={deleteSalesOrder}
            statuses={["All", "Draft", "Pending for Approval", "Approved", "Rejected", "Closed"]}
            kpiCards={[
                { label: "Total Sales Orders", key: "total", icon: FiFileText, color: T.accent },
                { label: "Pending", key: "pending", icon: FiClock, color: T.warning },
                { label: "Approved", key: "approved", icon: FiCheckCircle, color: T.success },
                { label: "Rejected", key: "rejected", icon: FiXCircle, color: T.danger },
                { label: "Closed", key: "closed", icon: FiCheckCircle, color: T.textMuted },
            ]}
            previewFields={[
                { icon: FiClock, label: "Date", key: "date" },
                { icon: FiCalendar, label: "Delivery Date", key: "deliveryDate" },
                { icon: FiHash, label: "Customer PO No.", key: "custPONo" },
                { icon: FiUser, label: "Contact Person", key: "contactPerson" },
                { icon: FiHome, label: "Company Name", key: "customer" },
                { icon: FiDollarSign, label: "Grand Total", key: "grandTotal", render: (v) => fmtMYR(v) },
                { icon: FiCreditCard, label: "Payment Terms", key: "paymentTerms" },
            ]}
            searchOptions={[
                { key: "all", label: "All" },
                { key: "id", label: "SO No." },
                { key: "date", label: "Date" },
                { key: "contactPerson", label: "Contact Person" },
                { key: "customer", label: "Company Name" },
            ]}
        />
    );
}
